import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { emojiObj } from './EmojiList';
const CloseIcon = (props) => (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "#fff", viewBox: "0 0 16 16", onClick: props.onClose }, { children: _jsx("path", { d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" }) })));
const EmojiSelector = (props) => {
    const EmojiSelectorWrapper = styled.div `
    pointer-events: auto;
    position: relative;
    border-radius: 8px;
    background: #1d1d21;
    width: 375px;
    padding: 16px;
    height: 200px;
    display: flex;
    flex-direction: column;
    ::-webkit-scrollbar {
      width: 0px;
    }
    .emoji-list {
      margin-top: 8px;
      display: grid;
      grid-template-columns: repeat(11, 1fr);
      gap: 8px;
      cursor: pointer;
      overflow: scroll;
      height: 170px;
    }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .title {
      color: #b5b5b5;
      font-family: Helvetica Neue;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 14.4px;
    }
  `;
    return (_jsx(EmojiSelectorWrapper, { children: _jsxs("div", Object.assign({ className: "emojis-wrapper" }, { children: [_jsxs("div", Object.assign({ className: "header" }, { children: [_jsx("span", Object.assign({ className: "title" }, { children: "All emojis" })), _jsx(CloseIcon, { onClose: props.onClose })] })), _jsx("div", Object.assign({ className: "emoji-list" }, { children: Object.values(emojiObj).flatMap((emojiItems) => emojiItems.map((emojiItem, id) => (_jsx("div", Object.assign({ onClick: () => props.onEmojiSelected(emojiItem.emoji) }, { children: emojiItem.emoji }), emojiItem.emoji + id)))) }))] })) }));
};
export default EmojiSelector;
